import { CheckCircle, Target, Brain, Dumbbell, Heart } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";
import { useScrollReveal } from "@/hooks/useScrollReveal";

const AboutMe = () => {
  const { t } = useLanguage();
  useScrollReveal();

  const services = t("aboutMe.services") as string[];

  const storyBlocks = [
    { 
      icon: Target, 
      title: t("aboutMe.storyTitle"), 
      content: t("aboutMe.story") 
    },
    { 
      icon: Brain, 
      title: t("aboutMe.mistakesTitle"), 
      content: t("aboutMe.mistakes") 
    },
    { 
      icon: Dumbbell, 
      title: t("aboutMe.methodologyTitle"), 
      content: t("aboutMe.methodology") 
    },
    { 
      icon: Heart, 
      title: t("aboutMe.missionTitle"), 
      content: t("aboutMe.mission") 
    },
  ];

  return (
    <section id="about-me" className="py-20 bg-card/30">
      <div className="container mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-16 scroll-reveal">
          <h2 className="text-4xl md:text-5xl font-black mb-6">
            {t("aboutMe.title")}
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto leading-relaxed">
            {t("aboutMe.personalInfo")}
          </p>
        </div>

        {/* Story Grid */}
        <div className="grid md:grid-cols-2 gap-8 mb-16">
          {storyBlocks.map((block, index) => {
            const Icon = block.icon;
            return (
              <div 
                key={index} 
                className="card-premium scroll-reveal"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                <div className="flex items-start gap-4">
                  <div className="p-3 rounded-lg bg-primary/10 flex-shrink-0">
                    <Icon className="h-6 w-6 text-primary" />
                  </div>
                  <div className="flex-1">
                    <h3 className="font-bold text-lg mb-3">{block.title}</h3>
                    <p className="text-sm text-muted-foreground leading-relaxed">
                      {block.content}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Services Section */}
        <div className="scroll-reveal" style={{ animationDelay: '400ms' }}>
          <div className="card-premium p-8 max-w-4xl mx-auto">
            <h3 className="text-2xl font-bold text-center mb-8">
              {t("aboutMe.howICanHelpTitle")}
            </h3>
            
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
              {services.map((service, index) => (
                <div 
                  key={index} 
                  className="flex items-start gap-3 p-4 rounded-lg bg-background/50 border border-border/50 hover:border-primary/50 transition-colors"
                >
                  <CheckCircle className="h-5 w-5 text-primary mt-0.5 flex-shrink-0" />
                  <span className="text-sm text-muted-foreground leading-relaxed">{service}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutMe;
